import { baseUrl } from "./index";
import { logout } from "./logout";

async function fetchWithAuth(url, options) {
  const response = await fetch(url, options);

  if (response.status === 401 || response.status === 403) {
    logout();
    throw new Error("Unauthorized or Forbidden - user logged out");
  }

  if (!response.ok) {
    console.log("Erro na resposta da API:", response.statusText);
    throw new Error("Network response was not ok");
  }

  const data = await response.json();

  if (data.error) {
    console.log("Erro no JSON da resposta:", data.error);
    throw new Error(data.error);
  }

  return data;
}

export async function listFavorites(userId) {
  return fetchWithAuth(`${baseUrl}/favorites/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
}

export async function addFavorite(propertyId) {
  return fetchWithAuth(`${baseUrl}/favorites/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ property_id: propertyId }),
  });
}

export async function removeFavorite(propertyId) {
  return fetchWithAuth(`${baseUrl}/favorites/`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ property_id: propertyId }),
  });
}
